// @ts-nocheck
import * as React from "react"
import { Pagination, Virtual } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/pagination"
import { useApi } from '../config/state'

import { ResponseSolutions } from '../types/api'


// Context
import { ModalContext } from "../contexts/modalContext";

export default ({ data }: { data: SolutionSection }) => {
    const slideView = data.cards.length <= 3 ? 3 : 'auto'

    return (
        <React.Fragment>
            <h2 className='solution__section-title' data-aos='fade-up'>{data?.title}</h2>
            <div
                className="description-seccion-cards"
                data-aos='fade-up'
                dangerouslySetInnerHTML={{ __html: data?.description }}
            />
            {
                data?.title.length ? (
                    <Swiper
                        modules={[Pagination, Virtual]}
                        spaceBetween={20}
                        pagination={{
                            "clickable": true
                        }}
                        id='workCarousel'
                        breakpoints={{
                            480: {
                                slidesPerView: 'auto'
                            },
                            991: {
                                slidesPerView: slideView
                            }
                        }}
                        data-aos='fade-up'
                    >
                        {
                            data.cards.map((cardInfo: SolutionCards, indexCard: number) => (
                                <SwiperSlide key={indexCard}>
                                    <WorkCard {...cardInfo} />
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                ) : (
                    <FinancialInclusion cards={data.cards} />
                )
            }

        </React.Fragment>
    )
}

const FinancialInclusion = ({ cards }) => {
    const [cardFI, setCardFI] = React.useState(cards)
    const dataApi = useApi<ResponseSolutions>(state => state.data)
    const slideView = cards.length <= 3 ? 3 : 'auto'

    React.useEffect(() => {
        if (Object.entries(dataApi).length === 0) return;
        drupalSettings.react.nodo.title.includes('Calera') && changeDataApi(dataApi, 2)
        drupalSettings.react.nodo.title.includes('Apan') && changeDataApi(dataApi, 1)
    }, [dataApi])

    const escapeAndAllowSmall = (str: string) => {
        return str.replace(/<(?!\/?small>)/g, "&lt;").replace(/>/g, "&gt;")
    }

    const changeDataApi = (dataApi: ResponseSolutions, index: number) => {
        const newCardList = dataApi.data[index].financialInclusion.subsidy.map(card => {
            return {
                title: `${card.current.toFixed(2)} ${escapeAndAllowSmall(`<small>${card.unit}</small>`)}`,
                subtitle: card.name,
                desc: card.description,
                fondo: false
            }
        })
        setCardFI(newCardList)
    }

    return (
        <React.Fragment>
            {cardFI.length && (
                <Swiper
                    modules={[Pagination, Virtual]}
                    spaceBetween={20}
                    pagination={{ clickable: true }}
                    id='workCarousel'
                    breakpoints={{
                        480: { slidesPerView: 'auto' },
                        991: { slidesPerView: slideView }
                    }}
                    data-aos='fade-up'
                >
                    {cardFI.map((cardInfo: SolutionCards, indexCard: number) => (
                        <SwiperSlide key={indexCard} virtualIndex={indexCard}>
                            <WorkCard {...cardInfo} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </React.Fragment>
    )
}

const WorkCard = ({ title, subtitle, desc, fondo }: SolutionCards) => {

    // Función simple para limpiar HTML y mantener saltos de línea
    const renderTextSafe = (html: string) => {
        if (!html) return ''
        return html.replace(/<\/?br\s*\/?>/gi, '\n').replace(/<\/?\w+[^>]*>/gi, '')
    }

    return (
        <ModalContext.Consumer>
            {({ toggleModal }) => (
                <div className={`work-card ${fondo ? 'work-card--bg' : ''}`} onClick={() => fondo && toggleModal(true, { url: fondo.url, alt: fondo.alt })}>
                    {fondo && <img className='work-card__bg-image' src={fondo.url} alt={fondo.alt} title={fondo.alt} />}
                    <h2 className='work-card__title'>
                        {renderTextSafe(title).split('\n').map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}
                    </h2>
                    <h3 className='work-card__subtitle'>{subtitle}</h3>
                    <div className='work-card__desc'>
                        {renderTextSafe(desc).split('\n').map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}
                    </div>
                    {fondo && <button className='work-card__more'>{window.currentLang == 'es' ? 'Ver imagen' : 'See image'}</button>}
                </div>
            )}
        </ModalContext.Consumer>
    )
}

export const ModalImage = () => {
    return (
        <ModalContext.Consumer>
            {({ isVisbleModal, currentCard, toggleModal }) => (
                <section className={`modal${!isVisbleModal ? ' hide' : ''}`}>
                    <div className="modal__container modal__container--image">
                        <span className="modal__close" onClick={() => toggleModal(false)} data-modal-close></span>
                        <img className="modal__image" src={currentCard.url} alt={currentCard.alt} title={currentCard.alt} />
                    </div>
                </section>
            )}
        </ModalContext.Consumer>
    )
}